<template>
    <div class="innerCont" v-if="modulo.translations[0]?.titolo || modulo.translations[0]?.sottotitolo">
        <div class="head" v-if="modulo.translations[0]?.titolo">
            <h2 class="title3">{{ modulo.translations[0]?.titolo }}</h2>
            <WebsiteCTA :cta="modulo.cta" :etichetta="modulo.translations[0]?.titolo" />
        </div>
        <div v-if="modulo.translations[0]?.sottotitolo" class="paragraph" v-html="modulo.translations[0]?.sottotitolo"></div>
    </div>
</template>

<script lang="ts" setup>
interface Props {
    modulo: any
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.innerCont {
    display: flex;
    flex-direction: column;
    gap: var(--font-size-body);

    .head {
        display: flex;
        flex-direction: row;
        gap: var(--margin-double);

        .linkMobile {
            display: none;
        }
        h2 {
            text-wrap: balance
        }
    }
}
</style>